import React from 'react'

class NextDayButton extends React.Component {

    render() {
        return <button onClick={() => this.props.nextTick() }>Next Day &gt;</button>
    }
}

export default NextDayButton